import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AbstractView } from 'src/app/core/abstract_view';
import { KpiCelulaAccessService } from 'src/app/core/services/kpi-celula-access.service';

@Component({
    selector: 'app-kpi-menu',
    templateUrl: './kpi-menu.component.html'
})
export class KpiMenuComponent extends AbstractView implements OnInit {
    public model: any[] = [];

    constructor(
        public messageService: MessageService,
        public router: Router,
        private celulaAccess: KpiCelulaAccessService
    ) {
        super(messageService, router);
    }

    ngOnInit(): void {
        this.buildModel();
        this.celulaAccess.refresh().subscribe(changed => {
            if (changed) {
                // AbstractView cachea los permisos al construir el componente: recárgalos antes de rearmar el menú
                try { this.auth = JSON.parse(localStorage.getItem('permisions') || '[]'); } catch { this.auth = []; }
                this.buildModel();
            }
        });
    }

    private buildModel(): void {
        this.model = [];

        // Dashboard: visible para todos (el control fino de qué ve dentro vive en el propio componente)
        this.model.push({
            label: 'Dashboard',
            icon: 'pi pi-chart-bar',
            routerLink: ['/administration/kpi/dashboard'],
        });

        if (this.getAuth(['VIEW_KPI_SELF'])) {
            this.model.push({
                label: 'Subir Mis KPI',
                icon: 'pi pi-plus',
                routerLink: ['/administration/kpi/crear'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_APPROVAL'])) {
            this.model.push({
                label: 'Aprobación KPI',
                icon: 'pi pi-users',
                routerLink: ['/administration/kpi/equipo'],
            });
            this.model.push({
                label: 'Delegar aprobador KPI',
                icon: 'pi pi-sitemap',
                routerLink: ['/administration/kpi/celulas'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_HR_APPROVAL'])) {
            this.model.push({
                label: 'Autorización DH',
                icon: 'pi pi-check-circle',
                routerLink: ['/administration/kpi/validacion'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_PAYROLL_DOWNLOAD'])) {
            this.model.push({
                label: 'Descargar KPI',
                icon: 'pi pi-download',
                routerLink: ['/administration/kpi/descarga'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_ASSIGNMENT'])) {
            this.model.push({
                label: 'Asignar KPI',
                icon: 'pi pi-tags',
                routerLink: ['/administration/kpi/tipos'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_ORG_CONFIG'])) {
            this.model.push({
                label: 'Config. Organizacional',
                icon: 'pi pi-id-card',
                routerLink: ['/administration/usuarios/org-info'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_CODE_CATALOG'])) {
            this.model.push({
                label: 'Catálogo de Códigos',
                icon: 'pi pi-list',
                routerLink: ['/administration/codigos'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_HR_APPROVAL'])) {
            this.model.push({
                label: 'Curvas de Pago',
                icon: 'pi pi-chart-line',
                routerLink: ['/administration/kpi/curvas'],
            });
        }

        if (this.getAuth(['MANAGE_KPI_PERIOD_CONFIG'])) {
            this.model.push({
                label: 'Períodos KPI',
                icon: 'pi pi-calendar-plus',
                routerLink: ['/administration/kpi/periodos'],
            });
        }
    }
}
